// kunyeMetni.js — GEREKÇE KÜNYESİ → MEVZUATIN KENDİ METNİ (29 Eyl 2026)
//
// 🔑 Serkan (29 Eyl): kural setine aykırı atamada gerekçenin yanında ⓘ,
//    tıklayınca maddenin kendisi (seçenek B — *"bence B"*). 3 Eyl'deki kural
//    da aynı: *"tıklayınca rule okunsun, SHT talimatında yazdığı gibi."*
//
// Künyeyi gerekçeyi ÜRETEN yer koyar (`fitness`, `standbyLimits`,
// `skpkLimits`, `medKisitlamaKontrol`, `ekipKapilari` → `kunyeli`); burası
// yalnız çevirir. Metin tahmin edilmez, özetlenmez:
//   'SHT-FTL/HG Md.16(1)'  → SHT-FTL/HG talimatının 16. maddesinin metni
//   'SHT-FCL FCL.065'      → SHT-FCL'nin FCL.065 maddesinin metni
//   'SHT-MED OML'          → AMC2 MED.B.001 kısıtlama kodunun tanımı
// Bulunamazsa null döner — kart "metin bulunamadı" der, uydurmaz (İlke 1).
import { maddeMetni } from '../data/shtArticles';
import { FCL_MADDELERI } from '../data/fclArticles';
import { MED_KISITLAMALARI } from '../data/medLimitations';

/** @returns {{ kunye:string, metin:string, kaynak:string|null } | null} */
export function kunyeMetni(ref) {
  const k = String(ref || '').trim();
  if (k.startsWith('SHT-FTL/HG ')) {
    const metin = maddeMetni(k);
    return metin ? { kunye: k, metin, kaynak: 'SHT-FTL/HG' } : null;
  }
  if (k.startsWith('SHT-FCL ')) {
    // "FCL.060(a)(3)" → madde anahtarı "FCL.060" (metin madde bütünüdür)
    const madde = (k.slice(8).match(/^FCL\.\d+/) || [])[0];
    const metin = madde ? FCL_MADDELERI[madde] : null;
    return metin ? { kunye: k, metin, kaynak: 'SHT-FCL' } : null;
  }
  if (k.startsWith('SHT-MED ')) {
    const kod = k.slice(8);
    const m = MED_KISITLAMALARI.find(x => x.kod === kod);
    return m ? { kunye: k, metin: `${m.kod} — ${m.ad}${m.not ? `\n\n${m.not}` : ''}`,
                 kaynak: m.kaynak || null } : null;
  }
  return null;
}
